import { createContext, useContext } from 'react'

import { AlertsPayload, AlertsResponse } from '~bank-alerts/types'

export type TablePrefix =
  | 'uploads'
  | 'applications'
  | 'CTRs'
  | 'bsaBatches'
  | 'SARs'
  | 'monthlyAnalytics'
  | 'quarterlyAnalytics'
  | 'annualReviews'
  | 'adverseMedia'
  | 'highRiskReview'

type AlertsContextValue = {
  data: AlertsResponse
  isTableLoading: (tablePrefix: TablePrefix) => boolean
  successfullyLoaded: boolean
  onFilterChange: (filter: Partial<AlertsPayload>, tablePrefix: TablePrefix) => Promise<void>
  search: Partial<AlertsPayload>
  invalidate: () => void
  onPageChange: (page: number, size: number, prefix: TablePrefix) => void
  clear: () => void
}

export const AlertsContext = createContext<AlertsContextValue | null>(null)

export const useAlertsContext = () => {
  const context = useContext(AlertsContext)

  if (!context) {
    throw new Error('useAlertsContext must be used within an AlertsContext.Provider')
  }

  return context
}
